import React, { Component, Fragment } from 'react';

import { withStyles } from '@material-ui/core/styles';
import { Typography, Grid } from '@material-ui/core';
import { VSpacer } from 'sm-react-components';

import AbstractPieChart from './AbstractPieChart';
import * as formatters from '../../formatters';

const styles = {};

const strings = {
    failed: 'Failed',
    success: 'Success',
    in_progress: 'Loading'
};
class StatusPieChart extends Component {
    constructor(props) {
        super(props);
        this.state = {
            values: [],
            ...this.genState(props)
        };
    }
  genState = props => {
      const { statistics } = props;
      let counts = { failed: 0, success: 0, in_progress: 0 };
      if (statistics === undefined || statistics.values === undefined) {
          return;
      }
      statistics.values.forEach(value => {
          counts.failed += value.failed || 0;
          counts.success += value.success || 0;
          counts.in_progress += value.in_progress || 0;
      });
      const values = Object.keys(counts).map(key => ({
          angle: counts[key],
          label: key,
          count: counts[key],
          color: formatters.statusColor(key)
      }));
      return { values };
  };

  componentWillReceiveProps = props => {
      this.setState(this.genState(props));
  };

  render() {
      const { values } = this.state;
      const { width, withPercentage } = this.props;
      const sum = values.reduce((p, n) => p + n.count, 0);
      return (
          <Fragment>
              <Grid item md={width || 3} sm={12}>
                  <Typography variant="h5">Request status</Typography>
                  <AbstractPieChart values={values} color />
              </Grid>
              {withPercentage && (
                  <Grid item md={6}>
                      <Grid
                          container
                          direction="column"
                          justify="center"
                          style={{ height: '100%' }}
                      >
                          {values.map(v => (
                              <Fragment key={`fragmentstatus${v.label}`}>
                                  <Grid item key={`itemstatus${v.label}`}>
                                      <Grid container key={`containerstatus${v.label}`}>
                                          <Grid item lg={6} key={`itemitemstatus${v.label}`}>
                                              <Typography
                                                  variant="h6"
                                                  key={`typograph1status${v.label}`}
                                              >
                                                  {strings[v.label]}
                                              </Typography>
                                          </Grid>
                                          <Grid item lg={6} key={`itemi2temstatus${v.label}`}>
                                              <Typography
                                                  key={`typography2status${v.label}`}
                                                  variant="h6"
                                              >{`${Math.floor((v.count / sum) * 100)}%`}</Typography>
                                          </Grid>
                                      </Grid>
                                  </Grid>
                                  <VSpacer medium key={`vspacerstatus${v.label}`} />
                              </Fragment>
                          ))}
                      </Grid>
                  </Grid>
              )}
          </Fragment>
      );
  }
}

export default withStyles(styles)(StatusPieChart);
